import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const HongKongFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_14916'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_14916)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 14H20V0H0V14Z'
					fill='#F0371D'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M9.98901 5.70203C10.6767 5.13791 10.7186 5.01176 10.8833 4.51476C10.9383 4.34887 10.8995 4.21262 10.8537 4.05171C10.7877 3.8197 10.707 3.53641 10.8719 3.03907C10.1215 2.80014 9.24973 3.40128 8.92465 4.38175C8.59958 5.36223 8.94434 6.35075 9.6947 6.58968C9.82903 6.63246 9.81397 6.60153 9.7732 6.51779C9.70166 6.37086 9.55095 6.06135 9.98901 5.70203ZM8.5648 6.73236C8.22987 5.91705 8.12036 5.83908 7.68896 5.53192C7.54497 5.42939 7.40075 5.42345 7.23044 5.41642C6.98486 5.4063 6.68502 5.39393 6.25332 5.08656C5.78957 5.71209 6.10355 6.71042 6.95461 7.31638C7.80568 7.92235 8.87154 7.90649 9.33529 7.28096C9.41831 7.16898 9.38365 7.17346 9.28978 7.18558C9.12508 7.20686 8.77814 7.25168 8.5648 6.73236ZM12.8576 7.17772C12.3243 7.17772 12.189 7.17772 11.429 6.71105C10.9449 6.4138 10.6911 6.64991 10.5707 6.76199C10.502 6.82587 10.4766 6.84947 10.4766 6.71105C10.4766 5.93785 11.3294 5.31105 12.3814 5.31105C13.4334 5.31105 14.2862 5.93785 14.2862 6.71105C13.7525 6.71105 13.5026 6.87377 13.2978 7.00703C13.1558 7.09946 13.0356 7.17772 12.8576 7.17772ZM12.8576 6.30003C12.8576 6.42889 12.751 6.53336 12.6195 6.53336C12.488 6.53336 12.3814 6.42889 12.3814 6.30003C12.3814 6.17116 12.488 6.06669 12.6195 6.06669C12.751 6.06669 12.8576 6.17116 12.8576 6.30003ZM10.8948 8.36499C10.6767 9.21752 10.7186 9.34368 10.8833 9.84067C10.9383 10.0066 11.0514 10.0944 11.185 10.1982C11.3776 10.3479 11.6128 10.5306 11.7777 11.0279C12.528 10.789 12.8728 9.80049 12.5477 8.82002C12.2227 7.83954 11.3508 7.2384 10.6005 7.47733C10.4661 7.52011 10.4969 7.53645 10.5801 7.58071C10.7261 7.65837 11.0337 7.82196 10.8948 8.36499ZM11.7351 9.56945C11.61 9.60928 11.4757 9.5422 11.4351 9.41964C11.3945 9.29709 11.4629 9.16545 11.588 9.12563C11.713 9.08581 11.8473 9.15288 11.888 9.27544C11.9286 9.398 11.8602 9.52963 11.7351 9.56945ZM9.12459 8.37816C8.22986 8.43838 8.12036 8.51635 7.68896 8.82351C7.54497 8.92604 7.49463 9.05861 7.43519 9.21518C7.34947 9.44094 7.24481 9.71658 6.81312 10.024C7.27687 10.6495 8.34273 10.6653 9.1938 10.0594C10.0449 9.45341 10.3588 8.45509 9.89509 7.82956C9.81207 7.71758 9.8057 7.75127 9.78846 7.84251C9.75822 8.00258 9.6945 8.33979 9.12459 8.37816ZM8.21538 9.53358C8.13809 9.42932 8.16167 9.2834 8.26805 9.20766C8.37444 9.13191 8.52333 9.15502 8.60063 9.25928C8.67792 9.36353 8.65433 9.50945 8.54795 9.5852C8.44157 9.66095 8.29267 9.63783 8.21538 9.53358ZM7.16254 6.24198C7.23983 6.13773 7.38873 6.11462 7.49511 6.19036C7.60149 6.26611 7.62508 6.41203 7.54779 6.51628C7.47049 6.62054 7.3216 6.64365 7.21521 6.5679C7.10883 6.49216 7.08525 6.34624 7.16254 6.24198ZM10.0316 4.24354C10.1566 4.28336 10.2251 4.415 10.1844 4.53755C10.1438 4.66011 10.0095 4.72719 9.88442 4.68736C9.75936 4.64754 9.69092 4.51591 9.73156 4.39335C9.77219 4.27079 9.90652 4.20372 10.0316 4.24354Z'
					fill='white'
				/>
			</g>
		</svg>
	);
};

export default HongKongFlagIcon;
